<template>
  <AisStats class="text-lg">
    <template #default="{ nbHits }">
      <span>{{ nbHits }} {{ $t('pages.category.products', nbHits) }}</span>
    </template>
  </AisStats>
</template>
